
import gsap from "gsap"

import {FooterFixed}  from "./ComponentFooterFixed";




export default function ComponentIntro(){
    const composant = document.querySelectorAll('.c-intro')
    if (composant.length > 0) {
      composant.forEach(comp => new Intro(comp))
    }
}


class Intro{
    constructor(el){
        this.DOM = el
        this.buttonContact = this.DOM.querySelector('.c-intro__contact button')

        this.firstTimeDisplay()
        FooterFixed.prototype.showContact()
        // this.controlOnEnterView()
    }

    controlOnEnterView(){
        gsap.to(this.DOM, {
            scrollTrigger : {
                trigger : this.DOM,
                scrub: true, 
                marker :true, 
                start : "top top",
                end: "bottom top",
                onEnterBack  : () => {
                        FooterFixed.prototype.hideContact()
                },
                onLeave : () => {
                    FooterFixed.prototype.showContact()
                } 
        }})
    }

    firstTimeDisplay(){
        const tl = gsap.timeline({})


        tl.set('.c-intro__title, .c-intro__subtitle, .c-intro__scroll', { opacity: 0 })
        
        tl.from('.c-intro__title', {
            autoAlpha: 0,
            y: 20,
            delay: .5,
        }).from('.c-intro__subtitle', {
            opacity: 0,
            y: 20,
            duration: .5,
        }).from('.c-intro__scroll', { opacity: 0, y: 10, delay: -0.5 })
        }

}

